import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../theme';
import { BadgeFallbackImage } from './BadgeFallbackImage';
export var BadgeSize;
(function (BadgeSize) {
    BadgeSize["Sm"] = "24px";
    BadgeSize["Md"] = "32px";
    BadgeSize["Lg"] = "40px";
})(BadgeSize || (BadgeSize = {}));
export function Badge({ borderColour = 'lollipop', size = BadgeSize.Lg, src, disabled, zIndex, title, }) {
    const [hasFailed, setHasFailed] = useState(false);
    if (typeof src === 'string') {
        return (React.createElement(Container, { "$borderColour": theme.colors[borderColour], "$size": size, "$src": src, "$disabled": disabled, "$zIndex": zIndex },
            hasFailed && React.createElement(BadgeFallbackImage, { title: title }),
            !hasFailed && (React.createElement("img", { width: '100%', height: '100%', src: src, alt: title, onError: () => setHasFailed(true) }))));
    }
    return (React.createElement(Container, { "$borderColour": theme.colors[borderColour], "$size": size, "$disabled": disabled, "$zIndex": zIndex, "$src": null }, src));
}
const Container = styled.div((props) => {
    return css `
    background-color: ${props.$borderColour};
    background-image: ${props.$src ? `url(${props.$src})` : 'none'};
    background-position: center;
    background-size: cover;
    height: ${props.$size};
    width: ${props.$size};
    border-radius: 50%;
    overflow: hidden;
    transition: box-shadow 0.2s ease-in-out;
    border: 2px solid ${props.$borderColour};
    filter: ${props.$disabled ? 'contrast(0.5)' : 'none'};
    z-index: ${props.$zIndex || 0};

    ${!props.$disabled &&
        css `
      &:hover {
        cursor: pointer;
        box-shadow: 0 0 0px 5px #f0f0f0;
      }
    `}
  `;
});
//# sourceMappingURL=Badge.js.map